import { GroupBase, MultiValueRemoveProps, components } from '@any-ui-react/select';
import classNames from 'classnames';

import { CloseIcon } from '@anyx/shared-icons';
import { BasicOption } from '@anyx/shared-utils';

export const MultiValueRemove = (
  props: MultiValueRemoveProps<BasicOption<string>, true, GroupBase<BasicOption<string>>>
) => {
  return (
    <components.MultiValueRemove
      {...props}
      innerProps={{
        ...props.innerProps,
        className: classNames(
          props?.innerProps?.className,
          'group rounded-l-none! hover:bg-[#D4D8DC]!'
        ),
      }}
    >
      <CloseIcon className="text-gray-7 group-hover:text-gray-9 h-4 w-4" />
    </components.MultiValueRemove>
  );
};
